import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Text } from '@dossierhq/design';
import { useCallback, useContext } from 'react';
import { EntityDisplayDispatchContext } from '../../contexts/EntityDisplayDispatchContext.js';
import { PublishedDossierContext } from '../../contexts/PublishedDossierContext.js';
import { usePublishedEntity } from '../../hooks/usePublishedEntity.js';
import { EntityDisplayActions } from '../../reducers/EntityDisplayReducer/EntityDisplayReducer.js';
export function ReferenceFieldDisplay({ className, value }) {
    const { publishedClient } = useContext(PublishedDossierContext);
    const dispatchEntityDisplayState = useContext(EntityDisplayDispatchContext);
    const { entity, entityError: _error } = usePublishedEntity(publishedClient, value ?? undefined);
    const handleEntityClick = useCallback((event) => {
        event.preventDefault();
        if (!value)
            return;
        // open entity asynchronously to not fight with the "click to activate entity" functionality
        setTimeout(() => dispatchEntityDisplayState(new EntityDisplayActions.AddEntity(value.id)));
    }, [dispatchEntityDisplayState, value]);
    return entity ? (_jsxs(Column, { className: className, children: [_jsx(Text, { textStyle: "body2", marginBottom: 0, children: entity.info.type }), _jsx(Text, { textStyle: "body1", children: _jsx("a", { onClick: handleEntityClick, children: entity.info.name }) })] })) : null;
}
//# sourceMappingURL=ReferenceFieldDisplay.js.map